import { Filter, Users } from 'lucide-react'
import type { ListType } from '@/api/lists'

/** Dynamic (filters keep it up to date) or Static (hand-picked) — icon and label, never colour alone. */
export default function TypeBadge({ type }: { type: ListType }) {
  return type === 'dynamic' ? (
    <span className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700">
      <Filter size={11} /> Dynamic
    </span>
  ) : (
    <span className="inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-sky-50 text-sky-700">
      <Users size={11} /> Static
    </span>
  )
}

